export default "__VITE_ASSET__DrmW3u7p__"